import React from 'react';
import { createRoot } from 'react-dom/client';
import Form from './donations/Form';
import './styles.css';

const container = document.getElementById('donations-root');
if (!container) {
    throw new Error('Host container #donations-root not found');
}

const groups = window.wsoDonationFormData;
if (!groups) {
    console.error('Groups data is missing or invalid. The form cannot be rendered.');
}

const root = createRoot(container);
root.render(
  <React.StrictMode>
      {groups ? <Form groups={groups} isProd={groups.is_production} /> : (
          <div className="text-red-500 text-center p-4">
              The donation form is currently unavailable due to a configuration issue. Please try again later.
          </div>
      )}
  </React.StrictMode>
);